import { ReactNode } from "react";
import { Box, RadioGroup, Stack, useToken } from "@chakra-ui/react";
import { TUserReactionValuesWithConfig } from "src/components/user-reactions/types";
import { USER_REACTION_BAR_TEST_ID } from "src/components/user-reactions/user-reaction-bar-test-ids";
import { UserReactionOption } from "src/components/user-reactions/user-reaction-option";
import { calculatePercentage } from "src/utils/numbers/calculate-percentage";

interface IReactionBarProps {
    label: ReactNode;
    reactionValues: TUserReactionValuesWithConfig;
    highestReactionValue: number;
    selectedValue?: string;
    onReactionChange?: (value: number) => void;
    isPreview?: boolean;
    isPreviewClickable?: boolean;
    hideBar?: boolean;
    onClick?: () => void;
}

export const UserReactionBar = ({
    label,
    reactionValues,
    highestReactionValue,
    selectedValue,
    onReactionChange,
    isPreview,
    isPreviewClickable,
    hideBar,
    onClick,
}: IReactionBarProps) => {
    const [gray200, gray800] = useToken("colors", ["gray.200", "gray.800"]);
    const handleOnChange = (value: string) => {
        !isPreview && onReactionChange?.(Number(value));
    };

    const handleButtonClick = (value: number) => () => {
        !isPreview && onReactionChange?.(value);
    };

    return (
        <Box width="100%" data-test-id={USER_REACTION_BAR_TEST_ID}>
            <Box marginBottom={1} fontSize="md">
                {label}
            </Box>
            <RadioGroup
                onClick={onClick}
                onChange={handleOnChange}
                value={selectedValue}
                sx={{
                    ".chakra-radio": {
                        cursor: isPreview && !isPreviewClickable ? "default" : "pointer",
                    },
                    ".chakra-radio__control": {
                        height: "32px",
                        width: "32px",
                        borderWidth: "2px",
                        borderColor: isPreview ? `${gray200} !important` : `${gray800} !important`,
                        backgroundColor: "white !important",
                    },
                    ".chakra-radio__control[data-checked]": {
                        borderColor: `${gray800} !important`,
                    },
                    ".chakra-radio__control[data-checked]::before": {
                        color: gray800,
                        width: "20px",
                        height: "20px",
                    },
                }}
            >
                <Stack spacing={0} direction="row" borderRadius="0 0 4px 4px" overflow="hidden">
                    {reactionValues.map(({ text, value, backgroundColor, numberOfReactions }) => (
                        <UserReactionOption
                            onClick={handleButtonClick(value)}
                            key={value}
                            text={text}
                            value={String(value)}
                            backgroundColor={backgroundColor}
                            percentage={calculatePercentage(numberOfReactions, highestReactionValue)}
                            isPreview={isPreview}
                            isPreviewClickable={isPreviewClickable}
                            hideBar={!isPreview && hideBar}
                        />
                    ))}
                </Stack>
            </RadioGroup>
        </Box>
    );
};
